import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getOrderAdjustmentInput,
  getOrderAdjustmentsInput,
  OrderAdjustmentLiteModel,
  OrderAdjustmentModel,
} from './model';

export function useGetOrderAdjustments(
  input?: getOrderAdjustmentsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<OrderAdjustmentLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<OrderAdjustmentLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['order-adjustments', input?.params],
      () =>
        QueryFetchFunction({
          url: 'order-adjustments',
          params: input?.params,
        }),
      options,
    ),
    OrderAdjustmentLiteModel,
  );
}

export function useGetOrderAdjustment(
  input?: getOrderAdjustmentInput,
  options?: UseQueryOptions<ApiResult<OrderAdjustmentModel>, ApiError>,
): UseQueryResult<ApiResult<OrderAdjustmentModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['order-adjustments', input?.id],
      () =>
        QueryFetchFunction({
          url: `order-adjustments/${input?.id}`,
        }),
      options,
    ),
    OrderAdjustmentModel,
  );
}

export function getOrderAdjustmentsKey(input?: getOrderAdjustmentsInput) {
  return ['order-adjustments', input?.params];
}

export function getOrderAdjustmentKey(input?: getOrderAdjustmentInput) {
  return ['order-adjustments', input?.id];
}
